(function(root){'use strict';var designs=[
  {
    "id": "cozy-capybara",
    "name": "Cozy Capybara",
    "handle": "cozy-capybara-custom-holiday-photo-card",
    "width": 500,
    "height": 700,
    "background": "#fbf4e4",
    "accent": "#b67838",
    "photos": [
      {
        "x": 50,
        "y": 49,
        "w": 400,
        "h": 224
      }
    ],
    "texts": [
      {
        "key": "greeting",
        "label": "Holiday greeting",
        "value": "Warm & Cozy Wishes",
        "x": 250,
        "y": 558,
        "size": 37,
        "font": "serif",
        "color": "#314737",
        "width": 396,
        "spacing": 0
      },
      {
        "key": "message",
        "label": "Message",
        "value": "May your holidays be filled with little joys",
        "x": 250,
        "y": 590,
        "size": 19,
        "font": "serif",
        "color": "#314737",
        "width": 390,
        "spacing": 0
      },
      {
        "key": "names",
        "label": "Names",
        "value": "With love, the Parker family",
        "x": 250,
        "y": 623,
        "size": 22,
        "font": "serif",
        "color": "#314737",
        "width": 390,
        "spacing": 0
      },
      {
        "key": "year",
        "label": "Year",
        "value": "2026",
        "x": 250,
        "y": 654,
        "size": 15,
        "font": "serif",
        "color": "#314737",
        "width": 160,
        "spacing": 2
      }
    ],
    "description": "Send a little comfort with every card. Our cheerful capybara mascot settles in with a warm mug and a cranberry scarf, surrounded by evergreen sprigs and tiny stars. Add one favorite photo, then personalize your greeting, message, names, and year. Watch every edit appear live in the design fonts.",
    "seo": "Create a cozy 5\u00d77 capybara holiday photo card with your photo, names, message, and year. Edit text live. Premium cardstock and envelopes included.",
    "artUrl": "https://ucarecdn.com/9b5fd36b-2823-4a57-abee-6b72ce7d0a93/",
    "artFile": "fp-capybara-art-cozy-capybara.png",
    "decoration": "illustration"
  },
  {
    "id": "capybara-cheer",
    "name": "Capybara Cheer",
    "handle": "capybara-cheer-custom-holiday-photo-card",
    "width": 700,
    "height": 500,
    "background": "#fbf4e4",
    "accent": "#b67838",
    "photos": [
      {
        "x": 353,
        "y": 41,
        "w": 314,
        "h": 414
      }
    ],
    "texts": [
      {
        "key": "greeting",
        "label": "Holiday greeting",
        "value": "A Little Holiday Cheer",
        "x": 178,
        "y": 310,
        "size": 34,
        "font": "serif",
        "color": "#314737",
        "width": 302,
        "spacing": 0
      },
      {
        "key": "message",
        "label": "Message",
        "value": "Wishing you a merry little season",
        "x": 178,
        "y": 354,
        "size": 20,
        "font": "serif",
        "color": "#314737",
        "width": 300,
        "spacing": 0
      },
      {
        "key": "names",
        "label": "Names",
        "value": "From the Bennett family",
        "x": 178,
        "y": 396,
        "size": 23,
        "font": "serif",
        "color": "#314737",
        "width": 300,
        "spacing": 0
      },
      {
        "key": "year",
        "label": "Year",
        "value": "2026",
        "x": 178,
        "y": 438,
        "size": 15,
        "font": "serif",
        "color": "#314737",
        "width": 150,
        "spacing": 2
      }
    ],
    "description": "A small friend with a big helping of holiday cheer. A rosy-cheeked capybara in a festive hat sits beside a little Christmas tree and wrapped gifts, while your favorite portrait fills the other half of this playful landscape card. Personalize the greeting, message, names, and year with fixed-font live editing.",
    "seo": "Personalize a 5\u00d77 capybara Christmas photo card with your photo, names, message, and year. Preview edits live. Cardstock and envelopes included.",
    "artUrl": "https://ucarecdn.com/9322e105-1d30-486c-b3ae-e9949566d3ff/",
    "artFile": "fp-capybara-art-capybara-cheer.png",
    "decoration": "illustration"
  }
];root.FoxPrintHolidayDesigns=designs;if(typeof module!=='undefined'&&module.exports)module.exports=designs;}(typeof window!=='undefined'?window:globalThis));
